import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Grid } from "@/comn/components";
import { comnUtils } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button } from "@/comn/components"; // 화면 구성 컴포넌트
import { useForm, useFetch, useResource, useGrid, useStore, useToast, useAuth, usePage } from "@/comn/hooks"; // hook
import { URLS, APIS, SF_BLL_REUS_LIST_SRCH, SG_BLL_REUS_LIST } from "./services/OsciBllReusService"; // 서비스
import dayjs from "dayjs";

/*
 * Bill Reuse List
 * !== 고지 재사용 목록 ==!
 */
export const OSCI0403004Q = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    useResource({
        defaultSchema: [
            { area: "cstmCd" },
            { area: "coCd" },
            { area: "comnCd", comnCd: "OSC0057" },
            { area: "comnCd", comnCd: "OSC0020" },
            { area: "comnCd", comnCd: "OSC0096" },
            { area: "comnCd", comnCd: "OSC0251" },
        ],
    });

    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003", "auth_osci0021"],
    }); // Page Unique identifier !== 화면 고유 식별자 ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!
    const [isVisibleNewBtn, setIsVisibleNewBtn] = useState(false); // User define State !== 사용자 정의 스테이트 ==!

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Bill Cancellation List Search !== 고지 취소 목록 검색 ==!
        bllReusSrch: useForm({
            defaultSchema: SF_BLL_REUS_LIST_SRCH,
            defaultValues: {
                ...(pgeStore?.form || { reusCd: ["A"] }),
            },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Bill Cancellation List !== 고지 취소 목록 ==!
        bllReusList: useGrid({
            defaultSchema: SG_BLL_REUS_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get Bill Cancellation List !== 고지 취소 목록 조회 ==!
        getBllReusList: useFetch({
            api: (page = grid.bllReusList.page) => {
                let data = {
                    ...form.bllReusSrch.getValues(),
                    orgCd: auth.get("orgCd"),
                };
                return APIS.getBllReusList(data, page, grid.bllReusList.size);
            },
            enabled: comnUtils.isEmpty(form.bllReusSrch.errors),
            key: [grid.bllReusList.page, grid.bllReusList.size],
            onSuccess: (data) => {
                setStore(pgeUid, {
                    form: form.bllReusSrch.getValues(),
                    page: grid.bllReusList.page,
                    size: grid.bllReusList.size,
                });
            },
            onError: () => {},
            showToast: true,
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Get Bill Cancellation List !== 고지 취소 목록 조회 ==!
        getBllReusList: () => {
            form.bllReusSrch.handleSubmit(
                (data) => {
                    grid.bllReusList.setPage(0);
                    fetch.getBllReusList.fetch(0);
                },
                (data) => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },
    };

    const render = {
        grid_BllReusList: {
            cell: {
                bllNo: (props: any) => {
                    const { rowValues } = props;
                    return (
                        <span style={{ color: "blue" }}>
                            <Link
                                to={`${URLS.osci0403005q}/${rowValues.bllMgmtId}${
                                    rowValues.reusRqstSn ? `?reusRqstSn=${rowValues.reusRqstSn}` : ""
                                }`}
                            >{`${rowValues.bllNo}`}</Link>
                        </span>
                    );
                },
            },
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        // 버튼 컨트롤
        if (auth.get("authList").includes("auth_osci0021") || auth.get("authList").includes("auth_osci0003")) {
            setIsVisibleNewBtn(true);
        }
    }, []);

    return (
        <Page>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.bllReusSrch.schema.bllNo}></Group.Control>
                                <Group.Control {...form.bllReusSrch.schema.txprTin}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.bllReusSrch.schema.reusDt}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.bllReusSrch.schema.reusStatCd}></Group.Control>
                            </Group.Row>
                            {/* <Group.Row>
                                <Group.Control {...form.bllReusSrch.schema.reusCd}></Group.Control>
                                <Group.Control {...form.bllReusSrch.schema.aprvPrcssStatCd}></Group.Control>
                            </Group.Row> */}
                        </Group.Section>
                        <Layout direction="row">
                            <Layout.Left>
                                <Button
                                    role="reset"
                                    onClick={() => {
                                        form.bllReusSrch.reset();
                                    }}
                                ></Button>
                            </Layout.Left>
                            <Layout.Right>
                                <Button
                                    role="search"
                                    onClick={() => {
                                        handler.getBllReusList();
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout>
                    </Group.Body>
                </Group>
            </form>

            <Group>
                <Group.Body>
                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="excelDown"
                                onClick={() => {
                                    grid.bllReusList.exportExcel({
                                        /* 다운로드 엑셀 파일명 (확장자 없이), 기본값 Export(년월일시분초) */
                                        excelName: dayjs().format("YYYY-MM-DD HH:mm:ss") + "_" + pgeUid,
                                        /* 다운로드 엑셀 시트명 , 기본값 Sheet */
                                        sheetName: "Sheet Name",
                                    });
                                }}
                            ></Button>
                        </Layout.Left>
                    </Layout>
                    <Group.Section>
                        <Grid
                            {...grid.bllReusList.grid}
                            data={fetch.getBllReusList.data?.bllReusList}
                            render={render.grid_BllReusList}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
            {isVisibleNewBtn && (
                <Layout.Left>
                    <Button
                        role="new"
                        onClick={() => {
                            navigate(URLS.osci0403006s + "/INSERT");
                        }}
                    ></Button>
                </Layout.Left>
            )}
        </Page>
    );
};
